module.exports = __webpack_public_path__ + "img/7.e2068707.jpg";